import { EditorState } from 'draft-js';

import { BbVideo } from '$/sections/Home/Profile/TeamIntegrations/Info/BombBomb/types';

import EditorUtils from '../../draft-js-plugins-utils/src';
import addImage from '../../draft-js-image-plugin/src/modifiers/addImage';
import updateImage from '../../draft-js-image-plugin/src/modifiers/updateImage';
import { updateLinkAtSelection } from '../../draft-js-anchor-plugin/src/components/AddLinkForm';

export default (editorState: EditorState, video: BbVideo): EditorState => {
  const entityKey = EditorUtils.getCurrentEntityKey(editorState);
  if (entityKey) {
    const updatedImageState = updateImage(editorState, video.thumbnail);
    const nextState = updateLinkAtSelection(updatedImageState, video.link);
    return nextState;
  } else {
    const addedImageState = addImage(editorState, video.thumbnail);
    const nextState = updateLinkAtSelection(addedImageState, video.link);
    return nextState;
  }
};
